import { ISubscriptionOverview } from "@api-clients/subscriptions";
import { CatsAPI, SubscriptionFilter } from "@api-clients/cats";

import { Allergen, SubscriptionItemType } from "@/primary-models";

const SPRINKLES_ALLERGENS: Set<Allergen> = new Set([
  Allergen.CHICKEN,
]);

export async function checkFreeSprinklesEligibility(
  catsAPI: CatsAPI,
  subscriptionId: number,
  subscriptionsOverview: ISubscriptionOverview,
): Promise<boolean> {
  if (!catsAPI) {
    return false;
  }

  const sub = subscriptionsOverview.freshMealPlans.find((plan) => plan.id === subscriptionId);
  if (!sub?.fulfillment) {
    return false;
  }

  // ONLY IF their next box is box two (i.e. only the first box has been charged)
  if (sub.fulfillment.chargeCount !== 1) {
    return false;
  }

  // IF they are not already subscribed to sprinkles
  const sprinklesItem = sub.items.find((item) => item.name === SubscriptionItemType.SPRINKLES);
  const hasPaidSprinkles =
    (sprinklesItem?.quantity ?? 0) > 0 && sprinklesItem?.postChargeQuantity === null;
  if (hasPaidSprinkles) {
    return false;
  }

  // AND IF the cat is not allergic to chicken
  const { cats } = await catsAPI.getCats({
    filterSubscription: SubscriptionFilter.HAS_FRESH,
    showSuppressedCats: false,
  });
  const thisCat = cats.find((c) => c.subscription?.subscriptionId === subscriptionId);
  if (thisCat?.details.allergies?.some((allergy) => SPRINKLES_ALLERGENS.has(allergy))) {
    return false;
  }

  return true;
}
